const entitySelector = state => state.entities
const resultsSelector = state => state.results

export {
  entitySelector,
  resultsSelector
}
